import { render } from "./Tarefas.vue?vue&type=template&id=43d221e9&scoped=true"
import script from "./Tarefas.vue?vue&type=script&lang=js"
export * from "./Tarefas.vue?vue&type=script&lang=js"

import "./Tarefas.vue?vue&type=style&index=0&id=43d221e9&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d221e9"]])

export default __exports__